import {
    Grid,
    Paper,
    Box,
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    SelectChangeEvent,
    Input,
    Button
} from "@mui/material";
import React, {ChangeEvent, FormEvent, useEffect, useState} from "react";
import {Link, LoaderFunctionArgs, useLoaderData, useParams} from "react-router-dom";
import {Reg, registrationLoader} from "../Registration";
import {
    adventureEquipment, benefits, boons,
    craftingMaterials, lcoScrolls,
    repNumberedTypes,
    superiorEquipment,
    tagSources,
    tagTypes
} from "../tag-sources";
import axios from "axios";
import TagDataGrid, {tableTag} from "../components/TagDataGrid";
import {DataGrid, GridColDef, GridToolbar} from "@mui/x-data-grid";
import {CustomToolbar} from "../components/CustomToolbar";


const columns: GridColDef[] = [
    {
        field: 'player',
        headerName: 'Player',
        width: 150,
        valueGetter: (params) => (params.row.registration.name)
        /*renderCell: (params) => (
            <Link to={'/pcs/' + params.row.registration.characterId}>{params.row.registration.name}</Link>
        )*/
    },
    {
        field: 'item', headerName: 'Item', headerAlign: "center"
    },

    {
        field: 'type', headerName: 'Type', headerAlign: "center",
    },
    {
        field: 'source', headerName: 'Source', headerAlign: "center",
    },
    {
        field: 'quantity', headerName: 'QTY', headerAlign: "center"
    },
    {
        field: 'repNumber',
        headerName: 'repNumber', align: "center", headerAlign: "center"
    }
]

export interface owedTag {
    id?: number,
    playerId: number,
    item: string,
    type: string,
    source: string,
    quantity: number,
    repNumber: string | null
}

export async function saveOwedTag(tag: owedTag, eventId: number) {
    const apiEndpoint = `/api/events/${eventId}/pcs/` + tag.playerId + '/tag'
    return await axios.post(apiEndpoint, tag).then(({data}) => {
        return data
    })
}

export async function getAllOwedTags(eventId: number): Promise<tableTag[]> {
    const apiEndpoint = `/api/events/${eventId}/tag`
    return await axios.get(apiEndpoint).then(({data}) => {
        return data as tableTag[]
    })
}

export default function Tags() {
    const {eventId} = useParams<{eventId: string}>()
    const eid = parseInt(eventId!)
    const loaderData = useLoaderData() as {registrations: Reg[], paidParking: boolean} | null;
    const [registrations, setReg] = useState(loaderData?.registrations ?? [] as Reg[]);
    const [playerId, setPlayerId] = useState("");
    const [tagType, setTagType] = useState("");
    const [tagSource, setTagSource] = useState("");
    const [tagQuantity, setTagQuantity] = useState(1)
    const [tagItem, setTagItem] = useState("");
    const [tagRepNumber, setTagRepNumber] = useState("");
    const [owedTagsList, setOwedTagsList] = useState([] as tableTag[])

    useEffect(() => {
        getAllOwedTags(eid).then(data => setOwedTagsList(data))
        console.log(playerId + ":" + tagType + ":" + tagSource + ":" + tagQuantity + ":" + tagItem + ":" + tagRepNumber)
    }, [])
    const onPlayerIdChange = (event: SelectChangeEvent) => {
        console.log("changing type to " + event.target.value)
        setPlayerId(event.target.value)
    }
    const onTypeChange = (event: SelectChangeEvent) => {
        console.log("changing type to " + event.target.value)
        setTagType(event.target.value)
    }
    const onSourceChange = (event: SelectChangeEvent) => {
        console.log("changing source to " + event.target.value)
        setTagSource(event.target.value)
    }
    const onQuantityChange = (event: SelectChangeEvent) => {
        console.log("changing quantity to " + event.target.value)
        setTagQuantity(parseInt(event.target.value))
    }
    const onItemChange = (event: SelectChangeEvent) => {
        console.log("changing item to " + event.target.value)
        setTagItem(event.target.value)
    }
    const onRepNumberChange = (event: ChangeEvent) => {
        console.log("changing repNumber to " + event.target.value)
        setTagRepNumber(event.target.value)
    }


    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        const owedTag: owedTag = {
            item: tagItem,
            playerId: parseInt(playerId),
            quantity: tagQuantity,
            repNumber: (tagRepNumber !== "") ? tagRepNumber : null,
            source: tagSource,
            type: tagType
        }
        saveOwedTag(owedTag, eid).then(() => {
            setTagQuantity(0)
            setTagItem("")
            setTagRepNumber("")
            getAllOwedTags(eid).then(data => setOwedTagsList(data))
        })


    }

    console.log(registrations)

    return (
        <React.Fragment>
            <h2>Tag Manager</h2>
            <Box component="form" noValidate onSubmit={handleSubmit}>
                <Paper elevation={2}>
                    <Grid container spacing={1} p={1}>
                        <Grid item xs={12} sm={6} md={4} p={1}>
                            <Paper elevation={2} sx={{p: 1}}>
                                <FormControl fullWidth>
                                    <InputLabel id="player-select-label">Player</InputLabel>
                                    <Select
                                        labelId="player-select-label"
                                        id="player-select"
                                        label="Player"
                                        required={true}
                                        value={playerId}
                                        onChange={onPlayerIdChange}
                                    >
                                        {registrations.sort((a, b) => {
                                            return (a.name < b.name) ? -1 : 1
                                        }).map((r) => {
                                            return <MenuItem key={r.playerId} value={r.playerId}>{r.name}</MenuItem>
                                        })}

                                    </Select>
                                </FormControl>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} p={1}>
                            <Paper elevation={2} sx={{p: 1}}>
                                <FormControl fullWidth>
                                    <InputLabel id="tag-type-selector-label">Item Type</InputLabel>
                                    <Select
                                        labelId="tag-type-selector-label"
                                        id="tag-type-select"
                                        label="Item Type"
                                        value={tagType}
                                        onChange={onTypeChange}
                                        required={true}
                                    >
                                        {tagTypes.sort().map((type) => {
                                            return <MenuItem key={type.value} value={type.value}>{type.name}</MenuItem>
                                        })}

                                    </Select>
                                </FormControl>
                            </Paper>

                        </Grid>
                        <Grid item xs={12} sm={6} md={4} p={1}>
                            <Paper elevation={2} sx={{p: 1}}>
                                <FormControl fullWidth>
                                    <InputLabel id="tag-source-selector-label">Source</InputLabel>
                                    <Select
                                        labelId="tag-source-selector-label"
                                        id="tag-source-select"
                                        label="Source"
                                        value={tagSource}
                                        onChange={onSourceChange}
                                        required={true}
                                    >
                                        {tagSources.sort().map((type: { name: string, value: string }) => {
                                            return <MenuItem key={type.value} value={type.value}>{type.name}</MenuItem>
                                        })}

                                    </Select>
                                </FormControl>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} p={1}>
                            <Paper elevation={2} sx={{p: 1}}>
                                <FormControl fullWidth>
                                    <InputLabel id="tag-quantity-input">Quantity</InputLabel>
                                    <Select
                                        value={tagQuantity.toString()}
                                        labelId="tag-quantity-input"
                                        id="tag-quantity"
                                        label="quantity"
                                        onChange={onQuantityChange}
                                    >
                                        <MenuItem value={1}>1</MenuItem>
                                        <MenuItem value={2}>2</MenuItem>
                                        <MenuItem value={3}>3</MenuItem>
                                        <MenuItem value={4}>4</MenuItem>
                                        <MenuItem value={5}>5</MenuItem>
                                        <MenuItem value={6}>6</MenuItem>
                                        <MenuItem value={7}>7</MenuItem>
                                        <MenuItem value={8}>8</MenuItem>
                                        <MenuItem value={9}>9</MenuItem>
                                        <MenuItem value={10}>10</MenuItem>
                                        <MenuItem value={11}>11</MenuItem>
                                        <MenuItem value={12}>12</MenuItem>
                                        <MenuItem value={13}>13</MenuItem>
                                        <MenuItem value={14}>14</MenuItem>
                                        <MenuItem value={15}>15</MenuItem>
                                        <MenuItem value={16}>16</MenuItem>
                                        <MenuItem value={17}>17</MenuItem>
                                        <MenuItem value={18}>18</MenuItem>
                                        <MenuItem value={19}>19</MenuItem>
                                        <MenuItem value={20}>20</MenuItem>
                                        <MenuItem value={21}>21</MenuItem>
                                        <MenuItem value={22}>22</MenuItem>
                                        <MenuItem value={23}>23</MenuItem>
                                        <MenuItem value={24}>24</MenuItem>
                                        <MenuItem value={25}>25</MenuItem>
                                        <MenuItem value={26}>26</MenuItem>
                                        <MenuItem value={27}>27</MenuItem>
                                        <MenuItem value={28}>28</MenuItem>
                                        <MenuItem value={29}>29</MenuItem>
                                        <MenuItem value={30}>30</MenuItem>
                                        <MenuItem value={31}>31</MenuItem>
                                        <MenuItem value={32}>32</MenuItem>
                                        <MenuItem value={33}>33</MenuItem>
                                        <MenuItem value={34}>34</MenuItem>
                                        <MenuItem value={35}>35</MenuItem>
                                        <MenuItem value={36}>36</MenuItem>
                                        <MenuItem value={37}>37</MenuItem>
                                        <MenuItem value={38}>38</MenuItem>
                                        <MenuItem value={39}>39</MenuItem>
                                        <MenuItem value={40}>40</MenuItem>
                                        <MenuItem value={41}>41</MenuItem>
                                        <MenuItem value={42}>42</MenuItem>
                                        <MenuItem value={43}>43</MenuItem>
                                        <MenuItem value={44}>44</MenuItem>
                                        <MenuItem value={45}>45</MenuItem>
                                        <MenuItem value={46}>46</MenuItem>
                                        <MenuItem value={47}>47</MenuItem>
                                        <MenuItem value={48}>48</MenuItem>
                                        <MenuItem value={49}>49</MenuItem>
                                        <MenuItem value={50}>50</MenuItem>


                                    </Select>
                                </FormControl>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} p={1}>
                            <Paper elevation={2} sx={{p: 1}}>
                                <FormControl fullWidth>
                                    <InputLabel id="tag-label">Item</InputLabel>
                                    <Select
                                        value={tagItem}
                                        labelId="tag-label"
                                        id="tag-input"
                                        label="Item"
                                        onChange={onItemChange}
                                        disabled={(tagType == "MAGIC_ITEM")}
                                    >
                                        {(tagType == "CRAFTING_MATERIAL") ? craftingMaterials.map((cm) =>
                                            <MenuItem key={cm} value={cm}>{cm}</MenuItem>) : null}
                                        {(tagType == "ADVENTURE_EQUIPMENT") ? adventureEquipment.map((ae) =>
                                            <MenuItem key={ae} value={ae}>{ae}</MenuItem>) : null}
                                        {(tagType == "SUPERIOR_EQUIPMENT") ? superiorEquipment.map((se) =>
                                            <MenuItem key={se} value={se}>{se}</MenuItem>) : null}
                                        {(tagType == "BOON") ? boons.map((boon) =>
                                            <MenuItem key={boon} value={boon}>{boon}</MenuItem>) : null}
                                        {(tagType == "COIN_BENEFIT") ? benefits.map((benefit) =>
                                            <MenuItem key={benefit} value={benefit}>{benefit}</MenuItem>) : null}
                                        {(tagType == "LCO_RITUAL_SCROLL") ? lcoScrolls.map((rit) =>
                                            <MenuItem key={rit} value={rit}>{rit}</MenuItem>) : null}
                                        {(tagType == "LCO_REAGENT") ?
                                            <MenuItem key={"LCO Reagent"} value={"LCO Reagent"}>LCO
                                                Reagent</MenuItem> : null}
                                    </Select>
                                </FormControl>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} p={1}>
                            <Paper elevation={2} sx={{p: 1}}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="tag-repNumber-input">Rep Number</InputLabel>
                                    <Input
                                        id="tag-input"
                                        value={tagRepNumber}
                                        onChange={onRepNumberChange}
                                        disabled={(!repNumberedTypes.includes(tagType as string))}
                                    />
                                </FormControl>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} height={"100%"} p={1}>
                            <Paper elevation={2} sx={{p: 1}}>
                                <Button variant="contained" type="submit" onClick={() => {
                                }}
                                        sx={{
                                            height: "100%",
                                            width: "100%",
                                            stretch: "100%"
                                        }}>Submit</Button>
                            </Paper>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
            <Paper elevation={2} sx={{p: 1, mt: 2}}>
                <DataGrid slots={{toolbar: CustomToolbar}}
                          localeText={{toolbarColumns: "", toolbarFilters: "", toolbarDensity: "", toolbarExport: ""}}
                          rows={owedTagsList}
                          disableRowSelectionOnClick
                          columns={columns}
                          autoHeight={true}
                          density={"compact"}
                          disableColumnMenu={true}
                />
            </Paper>
        </React.Fragment>
    )
}